import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export type Language = "ko" | "en";

export function useLanguage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentLanguage, setCurrentLanguage] = useState<Language>("ko");

  // 현재 경로에서 언어 감지
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/en")) {
      setCurrentLanguage("en");
    } else if (path.startsWith("/kr") || path === "/") {
      setCurrentLanguage("ko");
    }
  }, [location.pathname]);

  // 언어 변경 함수
  const changeLanguage = (language: Language) => {
    // localStorage에 저장
    localStorage.setItem("preferred-language", language);

    // 현재 경로에서 서브페이지 부분 추출
    const currentPath = location.pathname;
    let subPath = "";

    if (currentPath.startsWith("/kr/")) {
      subPath = currentPath.replace("/kr", "");
    } else if (currentPath.startsWith("/en/")) {
      subPath = currentPath.replace("/en", "");
    }

    // 해당 언어 페이지로 네비게이션 (서브페이지 유지)
    if (language === "ko") {
      navigate(`/kr${subPath}`);
    } else {
      navigate(`/en${subPath}`);
    }

    setCurrentLanguage(language);
  };

  // 언어 토글 함수
  const toggleLanguage = () => {
    const newLanguage = currentLanguage === "ko" ? "en" : "ko";
    changeLanguage(newLanguage);
  };

  return {
    currentLanguage,
    changeLanguage,
    toggleLanguage,
    isKorean: currentLanguage === "ko",
    isEnglish: currentLanguage === "en",
  };
}
